import { render, staticRenderFns } from "./SocialView.vue?vue&type=template&id=95a2cc1a&scoped=true&"
import script from "./SocialView.vue?vue&type=script&lang=js&"
export * from "./SocialView.vue?vue&type=script&lang=js&"
import style0 from "./SocialView.vue?vue&type=style&index=0&id=95a2cc1a&scoped=true&lang=css&"
import style1 from "./SocialView.vue?vue&type=style&index=1&lang=css&"
import style2 from "./SocialView.vue?vue&type=style&index=2&id=95a2cc1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a2cc1a",
  null
  
)

export default component.exports